const initialState = () => ({
  browser_id: null
})

export default {
  namespaced: true,

  state: initialState(),

  mutations: {
    assign(state, { browser_id = null } = {}) {
      state.browser_id = browser_id
    },
    reset(state) {
      Object.assign(state, initialState())
    }
  }
}
